import { Module } from '@/modules/core/app/constants/app.constants';
import { UserRoute, UserPathName } from '@/modules/ta/user/user.constants';
import { UserRouteConfig } from '@/modules/ta/user/UserRouteConfig';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';

export const router = [
  PageRouteConfig.factory(
    {
      path: `/${UserRoute.USERS}`,
      name: UserPathName.USERS,
      component: () => import(/* webpackChunkName: "users-page" */ './pages/UsersPage.vue'),
    },
    Module.USER
  ),
  PageRouteConfig.factory(
    {
      path: `/${UserRoute.USERS}/new`,
      name: UserPathName.USERFORM_NEW,
      component: () => import(/* webpackChunkName: "user-form-page" */ './pages/UserFormPage.vue'),
      props: true,
    },
    Module.USER
  ),
  UserRouteConfig.factory(
    {
      path: `/${UserRoute.USERS}/:id`,
      name: UserPathName.USERFORM,
      component: () => import(/* webpackChunkName: "user-form-page" */ './pages/UserFormPage.vue'),
      props: true,
    },
    Module.USER
  ),
  {
    path: `/${UserRoute.EDITSETTINGS}`,
    name: UserPathName.EDITSETTINGS,
    component: () =>
      import(/* webpackChunkName: "edit-settings-page" */ './pages/EditSettingsPage.vue'),
    props: true,
  },
];
